module.exports = __webpack_public_path__ + "static/media/Icons-20x20-Close_Gray.f30e212c.svg";